import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  Steps,
  Form,
  Input,
  Select,
  DatePicker,
  Card,
  Upload,
  Button,
  Modal,
  Empty,
  notification,
} from 'antd'
import styled from 'styled-components'

import lang from 'lang/en'

import { getCookie } from 'helper/cookie'
import { Table, Tag, Space } from 'antd'
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  InboxOutlined,
  MailOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import Emytystate from 'icons/createproject/supportneed.svg'
const initalState = {
  data: [],
  isLoading: true,
}

import ModalAddSupportNeed from 'common/SupportNeed/ModalAdd'
import ModalDeleteSupportNeed from 'common/SupportNeed/ModalDelete'
import NoPermissionSupportNeed from 'common/SupportNeed/NoPermissionSupportNeed'
const Header = styled.div``
const Body = styled.div``
const ContainerSN = styled.div``
const { TextArea } = Input

import {
  getResultSupportNeed,
  addSupportNeed,
  getResultOptionSupportNeed,
  deleteSupportNeed,
  updateSupportNeed,
  updateStatusSupportNeed,
  sendMailSupportNeed,
} from 'api/Project/supportneed'

import 'styleLess/signature/taskSupportneed.scss'

const Container = styled.div`
  margin-top: 32px;
  min-height: 500px;
  // background-color: darkblue;
`

const Supportneed = (props) => {
  const {
    idEditPRJ,
    statusProject,
    sendmailStatus,
    idsubtask,
    role,
    memberRole,
    checkStatusWaiting,
  } = props
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const language = getCookie('lang')
  const word = lang[language]
  const token = getCookie('access_token_admin')
  const [dataSupportNeed, setDataSupportNeed] = useState(initalState.data)
  const [modalState, setModalState] = useState(false)

  const [visibleDelete, setVisibleDelete] = useState(false)
  const [searchTerm, setsearchTerm] = useState(0)
  const companyIDUser = getCookie('companyId_project')
  const [checkBtn, setCheckBtn] = useState('')

  const [dataEdit, setDataEdit] = useState(initalState.data)

  //option
  const [dataOption, setDataOption] = useState(initalState.data)
  const [disableSelect, setDisableSelect] = useState(false)

  //typeBtn
  const [typeBtn, setTypeBtn] = useState()

  //view
  const [viewNameBtn, setViewNameBtn] = useState('')
  const [viewDisplayOk, setViewDisplayOk] = useState('')
  const [viewDisable, setViewDisable] = useState(false)

  //check role
  const [disabledBtn, setdisabledBtn] = useState(role)
  const [checkMember, setCheckMember] = useState(false)
  const getSupportNeed = async () => {
    getResultSupportNeed({
      project_id: parseInt(idEditPRJ),
      sprintflow_id: idsubtask,
      taskinbox: 'N',
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataSupportNeed([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataSupportNeed(data)
        } else {
          setDataSupportNeed([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataSupportNeed([])
        setIsLoading(false)
        console.error(error)
      })
  }

  //get option
  const getOption = async () => {
    getResultOptionSupportNeed({
      // company_id: 43,
      company_id: parseInt(companyIDUser),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataOption([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataOption(data)
        } else {
          setDataOption([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataOption([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getOption()
      getSupportNeed()
    }
    if (memberRole > 3) {
      setCheckMember(true)
      setDisableSelect(true)
    } else {
      //เช็คว่า โปรเจคนั้น สามารถแก้ไขได้มั้ย
      if (role == false) {
        setCheckMember(false)
        if (checkStatusWaiting == true) {
          setDisableSelect(true)
        } else {
          setDisableSelect(false)
        }
      } else {
        setCheckMember(true)
        if (checkStatusWaiting == true) {
          setDisableSelect(true)
        } else {
          setDisableSelect(false)
        }
      }
    }
  }, [token, checkStatusWaiting])

  const openNotificationWithIcon = (type, data, value) => {
    if (value == 'Done') {
      notification[type]({
        message: 'Success',
        description: 'You have been ' + value.toLowerCase() + '.',
        duration: 3,
      })
    } else {
      notification[type]({
        message: 'Success',
        description: 'You have been ' + value.toLowerCase() + 'ed.',
        duration: 3,
      })
    }
  }

  const onChange = (value, data) => {
    const dataArray = {
      project_id: parseInt(idEditPRJ),
      sprintflow_id: idsubtask,
      support_status: value,
    }
    try {
      updateStatusSupportNeed({
        supportneed_id: data.dataAll.id,
        params: dataArray,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          // setModalState(false)
          getSupportNeed()

          openNotificationWithIcon('success', data, value)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }
  // let mockStatusP = 4

  const onClickSendMail = (data) => {
    try {
      sendMailSupportNeed({
        supportneed_id: data.id,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          getSupportNeed()
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const ButtonSiteEliter = (data) => {
    if (disabledBtn == true) {
      if (checkMember == true) {
        return (
          <Button className="BTN_Previous edit-width-btn-supportneed" disabled={true}>
            <MailOutlined className="Icon-color" />
            {word['addtask_supportneed_btn_sendmail']}
          </Button>
        )
      } else {
        if (data.dataAll.sendmail_status != 'Y' && data.dataAll.enable_button != 'N') {
          return (
            <Button
              className="BTN_Previous edit-width-btn-supportneed"
              onClick={() => onClickSendMail(data)}
              disabled={false}
            >
              <MailOutlined className="Icon-color" />
              {word['addtask_supportneed_btn_sendmail']}
            </Button>
          )
        } else {
          return (
            <Button className="BTN_Previous edit-width-btn-supportneed" disabled={true}>
              <MailOutlined className="Icon-color" />
              {word['addtask_supportneed_btn_sendmail']}
            </Button>
          )
        }
      }
    } else {
      if (data.dataAll.sendmail_status != 'Y' && data.dataAll.enable_button != 'N') {
        return (
          <Button
            className="BTN_Previous edit-width-btn-supportneed"
            onClick={() => onClickSendMail(data)}
            disabled={false}
          >
            <MailOutlined className="Icon-color" />
            {word['addtask_supportneed_btn_sendmail']}
          </Button>
        )
      } else {
        return (
          <Button className="BTN_Previous edit-width-btn-supportneed" disabled={true}>
            <MailOutlined className="Icon-color" />
            {word['addtask_supportneed_btn_sendmail']}
          </Button>
        )
      }
    }
  }

  const View = (data) => {
    setModalState(true)
    setViewDisable(true)
    setViewDisplayOk('none')
    setViewNameBtn('Close')
    setDataEdit(data)
    setTypeBtn('edit')
  }

  const toolSiteEliter = (data) => {
    if (data.dataAll.sendmail_status == 'Y') {
      return (
        <div>
          <EyeOutlined onClick={() => View(data)} className="eyeoutlined" />
        </div>
      )
    } else {
      return (
        <div>
          <EditOutlined
            style={{ cursor: checkMember ? 'no-drop' : 'pointer' }}
            className="editoutlined"
            onClick={() => Editremark(data)}
          />
          <DeleteOutlined
            style={{ cursor: checkMember ? 'no-drop' : 'pointer' }}
            className="deleteoutlined"
            onClick={() => Deleteremark(data)}
          />
        </div>
      )
    }
  }
  const Editremark = (value) => {
    // if (disabledBtn == true) {
    if (checkMember == true) {
    } else {
      setViewDisable(false)
      setViewDisplayOk('')
      setViewNameBtn('')

      setTypeBtn('edit')
      setModalState(true)
      setDataEdit(value)
    }
  }
  const Deleteremark = (value) => {
    // if (disabledBtn == true) {
    if (checkMember == true) {
    } else {
      setDataEdit(value)
      setVisibleDelete(true)
    }
  }

  const dataSource = dataSupportNeed
    .filter((item) => {
      if (searchTerm === 0 || searchTerm === undefined) {
        return item
      } else if (searchTerm === item.support_status) {
        return item
      }
    })
    .map((item) => ({
      id: item.id,
      key: item.id,
      remark: item.description,
      status: item.support_status,
      type: item.support_type_id,
      dataAll: item,
    }))

  const columns = [
    {
      title: <h5>{word['addtask_supportneed_title_remark']}</h5>,
      dataIndex: 'remark',
      key: 'remark',
      width: 300,
      render: (text) => <p className="remark-style">{text}</p>,
    },
    {
      title: <h5>{word['addtask_supportneed_title_type']}</h5>,
      dataIndex: 'type',
      key: 'type',
      width: 130,
      render: (text) => {
        dataOption.map((item) => {
          if (text == item.id) {
            text = item.title
          }
        })
        return text
      },
    },
    {
      title: <h5>{word['addtask_supportneed_title_status']}</h5>,
      dataIndex: 'status',
      key: 'status',
      render: (status, data) => {
        if (status == 'Done') {
          return (
            <p style={{ marginLeft: 11 }}>{word['addtask_supportneed_value_status']}</p>
          )
        } else {
          return (
            <Select
              className="selectionassignee"
              placeholder="dropdown"
              style={{ width: 120 }}
              onChange={(e) => onChange(e, data)}
              defaultValue={status}
              disabled={disableSelect}
            >
              {mockStatusType.map((item) => (
                <Option value={item.status_name}>{item.status_name}</Option>
              ))}
            </Select>
          )
        }
      },
    },
    {
      title: <h5 className="actionT">{word['addtask_supportneed_title_action']}</h5>,
      render: (data) => (
        <div className="item-container">
          {toolSiteEliter(data)}
          {ButtonSiteEliter(data)}
        </div>
      ),
    },
  ]

  const [mockStatusType, setmockStatusType] = useState([
    {
      id: 1,
      status_name: 'Open',
      key: 'open',
    },
    {
      id: 2,
      status_name: 'In Progress',
      key: 'inprogress',
    },
    {
      id: 3,
      status_name: 'Done',
      key: 'done',
    },
    {
      id: 4,
      status_name: 'Cancel',
      key: 'cancel',
    },
  ])

  const FilterData = (item) => {
    if (item == [] || item == '') {
      return (
        <Table
          className="mytable-supportneed-project"
          columns={columns}
          dataSource={dataSource}
          pagination={false}
        />
        // <div className="no-data-container-task-subtask">
        //   <InboxOutlined className="icon" />
        //   <h2 className="coloremptychecklist">No Data</h2>
        // </div>
      )
    } else {
      return (
        <Table
          className="mytable-supportneed-project"
          columns={columns}
          dataSource={dataSource}
          pagination={false}
        />
      )
    }
  }

  const showModalStateAdd = () => {
    setViewDisable(false)
    setViewDisplayOk('')
    setViewNameBtn('')
    setTypeBtn('add')
    setModalState(true)
  }

  const playStateHeader = () => {
    if (dataSupportNeed.length == 0) {
      return <div></div>
    } else {
      return (
        <Col className="col2">
          <Select
            className="Select Select-Custom"
            placeholder="All "
            style={{ minWidth: '297px', borderRadius: '4px' }}
            size="large"
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(e) => onChangeSearch(e)}
          >
            <Option value={0}>All</Option>
            {mockStatusType.map((item) => (
              <Option value={item.status_name}>{item.status_name}</Option>
            ))}
          </Select>
          <Button
            disabled={checkMember}
            className="BTN_ClassA edit-width-btn-supportneed"
            onClick={() => showModalStateAdd()}
          >
            <PlusOutlined className="Icon-color" />
            {word['addtask_supportneed_btn_addnew']}
          </Button>
        </Col>
      )
    }
  }
  let arrayData = []
  const playStateBody = () => {
    if (dataSupportNeed.length == 0) {
      return (
        <div
          style={{
            flexDirection: 'column',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img  src={Emytystate}></img>
          <h2 className="coloremptychecklist">
            {word['addtask_supportneed_word_pleaseadd']}
          </h2>
          <Button
            style={{ marginTop: 32 }}
            className="BTN_ClassA edit-width-btn-kpi"
            disabled={checkMember}
            onClick={() => showModalStateAdd()}
          >
            <PlusOutlined className="Icon-color" />
            {word['addtask_supportneed_btn_addnewsupp']}
          </Button>
        </div>
      )
    } else {
      return (
        <div>
          {dataSource &&
            dataSource.filter((item) => {
              if (searchTerm === 0 || searchTerm === undefined) {
                arrayData.push(item)
              } else if (searchTerm === item.status) {
                arrayData.push(item)
              }
            })}

          <div className="layout-table-supportneed">
            <div className="desktop-style">{FilterData(arrayData)}</div>
          </div>
        </div>
      )
    }
  }

  const onChangeSearch = (value) => {
    setsearchTerm(value)
  }

  // if (memberRole > 2) {
  //   return <NoPermissionSupportNeed />
  // } else {
  return (
    <Container>
      <ContainerSN className="container-sn">
        <Header className="header">
          <Row className="row">
            <Col className="col1">{/* <h1>Support Need components</h1> */}</Col>
            {playStateHeader()}
          </Row>
        </Header>

        {/* <Body className="body"></Body> */}
        <div
          style={{
            marginTop: 38,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          {playStateBody()}
        </div>

        <ModalAddSupportNeed
          setModalState={setModalState}
          modalState={modalState}
          viewNameBtn={viewNameBtn}
          viewDisplayOk={viewDisplayOk}
          viewDisable={viewDisable}
          dataEdit={dataEdit}
          typeBtn={typeBtn}
          idEditPRJ={idEditPRJ}
          getSupportNeed={getSupportNeed}
          stateKPI={idsubtask}
          pageTaskInboxDetail={'createproject'}
        />
        <ModalDeleteSupportNeed
          idEditPRJ={idEditPRJ}
          setVisibleDelete={setVisibleDelete}
          visibleDelete={visibleDelete}
          dataEdit={dataEdit}
          getSupportNeed={getSupportNeed}
          pageTaskInboxDetail={'createproject'}
        />
      </ContainerSN>
    </Container>
  )
}
// }
export default Supportneed
